/**
 * Signup
 * Handles initial sign-up page by collecting data entered then forwarding to he defined landing page
 * 
 * Config Options
 * -- landingPage : Page that the user is sent to after data is collected
 */
define('components/captcha',[
    'jquery',
    'logging'
], function($, logging) {
    'use strict';
    
    var _ModuleName = "Captcha Support";

    var _data = {
        captchaSiteKey: '',
        validationToken: '',
        onValidationFns: []
    };

    var init = function(config) {
        logging.debug("Initializing Captcha Component", _ModuleName);

        if(config && config.captchaSiteKey) {
            _data.captchaSiteKey = config.captchaSiteKey;
        } else {
            logging.error('Captcha integration is included, but not configured. Add \'captchaSiteKey\' to config.', _ModuleName);
        }

        window.onValidCaptcha = function(token) {
            console.debug('captcha validated. handling.');

            // store token
            _data.validationToken = token;
    
            // process all stored callback functions
            _data.onValidationFns.forEach(function(fn) { fn(); });
        };
    }

    var run = function() {
        // if not configured, do not run
        if (!_data.captchaSiteKey) { return; }

        logging.debug("Running Captcha Component", _ModuleName);
        
        var $form = $('form');
        if ($form != null && $form.length > 0) {
            logging.debug('Configuring captcha callback function on global scope.', _ModuleName);

            logging.debug('Adding recaptcha div to form', _ModuleName);

            $form[0].innerHTML += "<div id='recaptcha' class='g-recaptcha' data-sitekey='" + _data.captchaSiteKey + "' data-callback='onValidCaptcha' data-size='invisible'></div>";

            logging.debug('Attaching ReCaptcha script to head', _ModuleName);

            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js';
            script.type = 'text/javascript';
            script.async = true;
            document.head.appendChild(script);
        } else {
            logging.error('Failed to get form and/or submit button. Unable to set up Captcha.', _ModuleName);
        }
    }

    var registerOnValidationFn = function(fn) {
        if (typeof fn !== 'function') {
            logging.error('captcha validation callback function provided is not a function', _ModuleName);
            return;
        }

        if (!_data.validationToken) {
            logging.debug('register captcha on validation function', _ModuleName);
            _data.onValidationFns.push(fn);
        } else {
            logging.debug('validation already complete. running validation function immediatly.', _ModuleName);
            fn();
        }
    }

    var validateCaptcha = function() {
        if (!_data.validationToken && !!window.grecaptcha) {
            console.debug('time to check captcha');
            window.grecaptcha.execute();
        } else {
            console.error('either we\'ve already validated, or window.grecaptcha does not exist.');
        }
    }

    return {
        init: init,
        run: run,
        captchaIsEnabled: (function () { return !!_data.captchaSiteKey }),
        captchaIsValidated: (function () { return !!_data.validationToken }),
        registerOnValidationFn: registerOnValidationFn,
        validateCaptcha:validateCaptcha
    }
});
